import { api } from '../utils/axios';

export const getSettings = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_SETTINGS_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_settings', data);
    dispatch({
      type: "GET_SETTINGS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_SETTINGS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateSettings = (data) => async (dispatch) => {
  

  dispatch({
    type: "UPDATE_SETTINGS_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_setting', data);
    dispatch({
      type: "UPDATE_SETTINGS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_SETTINGS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}
